import {
    CLICK_HERE_TO_SELECT,
    DELIVERY_TABS_LABELS,
    SELECTED_DELIVERY_TAB,
} from "@cart-client/constants/CartDeliverySpeed";
import { RenderingDetails } from "@swiggy-private/cart-types";
import { DELIVERY_SECTION_ELEMENT, isToingFlow } from "@swiggy-private/checkout-core";
import { format } from "@swiggy-private/js-utils";

export const getDeliveryTabLabel = (element: DELIVERY_SECTION_ELEMENT): string => {
    switch (element) {
        case DELIVERY_SECTION_ELEMENT.DELIVERY_TYPE:
            return isToingFlow() ? DELIVERY_TABS_LABELS.DELIVERY_MODES : DELIVERY_TABS_LABELS.DELIVERY_TYPE;
        case DELIVERY_SECTION_ELEMENT.TIP:
            return DELIVERY_TABS_LABELS.TIP;
        case DELIVERY_SECTION_ELEMENT.INSTRUCTIONS:
        case DELIVERY_SECTION_ELEMENT.SELF_DELIVERY:
            return DELIVERY_TABS_LABELS.INSTRUCTIONS;
        default:
            return "";
    }
};

export const getDeliverySectionA11yLabel = (
    renderDetail: Omit<RenderingDetails, "children">,
    selectedSection: DELIVERY_SECTION_ELEMENT | null,
) => {
    const label = getDeliveryTabLabel(renderDetail?.type?.toUpperCase() as DELIVERY_SECTION_ELEMENT);

    if (selectedSection === renderDetail?.type?.toUpperCase()) {
        return format(SELECTED_DELIVERY_TAB, label);
    }

    return format(CLICK_HERE_TO_SELECT, label);
};
